import { useEffect, useState } from 'react';
/**
 * Forms with input that is not saved yet (after Corly): while there is one, closing or reloading
 * the tab asks first, and the apps ask before a way out of the page (`hasUnsavedChanges`).
 */
const drafts = new Set();
const holdTab = (event) => {
    // The browser asks in its own words; a text of ours it would not show.
    event.preventDefault();
};
/** Whether something is unsaved right now - for the guard of a way out of the page. */
export function hasUnsavedChanges() {
    return drafts.size > 0;
}
/** Holds the tab while `dirty`; unmounting lets go, as saving or discarding does. */
export function useUnsavedChanges(dirty) {
    useEffect(() => {
        if (!dirty)
            return undefined;
        const draft = Symbol('draft');
        if (drafts.size === 0)
            window.addEventListener('beforeunload', holdTab);
        drafts.add(draft);
        return () => {
            drafts.delete(draft);
            if (drafts.size === 0)
                window.removeEventListener('beforeunload', holdTab);
        };
    }, [dirty]);
}
/**
 * Whether `values` differ from what they were when the form opened - the fields as the person
 * found them. Plain data only (text, numbers, lists): it is compared as JSON.
 */
export function useDraftChanged(values) {
    const [initial] = useState(() => JSON.stringify(values));
    const dirty = JSON.stringify(values) !== initial;
    useUnsavedChanges(dirty);
    return dirty;
}
//# sourceMappingURL=unsaved.js.map